import React from 'react'
import styled, {DefaultTheme} from 'styled-components'
import {transparentize} from 'polished'

import type {MarginProps, ResponsiveValue, StyleProps} from '../../'
import {convertLayoutProps} from '../../utils'

export interface TextProps extends MarginProps, React.HTMLAttributes<HTMLElement> {
  as?: React.ElementType
  className?: string
  children: React.ReactNode
  $styles?: StyleProps
  $color?: keyof DefaultTheme['colors']
  $align?: ResponsiveValue<'left' | 'right' | 'center'>
  $transparency?: number | string
  $variant?: ResponsiveValue<keyof DefaultTheme['typography']['paragraphs']>
}

const TextWithRef = React.forwardRef<HTMLElement, TextProps>((props, ref) => {
  const {as: Element = 'p', children, ...restProps} = props

  return (
    <Element ref={ref} {...restProps}>
      {children}
    </Element>
  )
})

TextWithRef.displayName = 'TextWithRef'

const Text = styled(TextWithRef)<TextProps>`
  ${({theme, $variant}) => theme.expandVariants($variant, theme.typography.paragraphs)}

  ${({theme, $styles, $align, $color = 'primaryIndigo', $transparency = 0, ...props}) =>
    theme.normalizeStyles({
      ...convertLayoutProps(props),
      color: $transparency
        ? transparentize($transparency, theme.colors[$color])
        : theme.colors[$color],
      textAlign: $align,
      ...$styles,
    })};
`

Text.displayName = 'Text'

export default Text
